const SUBDOMAIN = process.env.SUBDOMAIN
const HOST_DOMAIN = process.env.HOST_DOMAIN
const APP_INSIGHTS_INSTRUMENTATION_KEY =
  process.env.APP_INSIGHTS_INSTRUMENTATION_KEY
const AUTH_CLIENT_ID = process.env.AUTH_CLIENT_ID
const LD_CLIENT_ID = process.env.LD_CLIENT_ID

function stripTrailingSlashes(value) {
  return value?.replace(/\/+$/, '') || ''
}

/** Maps WAF-safe `returnTo` tokens to build-time redirect base URLs. */
const profileCompletionRedirectTargets = {
  efp: stripTrailingSlashes(process.env.EFP_APP_BASE_URL),
  'efp-local': stripTrailingSlashes(process.env.EFP_LOCAL_APP_BASE_URL),
}

/** Whether `returnTo` tokens ending in `-local` may redirect (local dev or any local URL configured at build). */
function allowProfileReturnLocalRedirect() {
  if (
    process.env.REACT_APP_ENV === 'local' ||
    process.env.REACT_APP_ENV === 'localApp'
  ) {
    return true
  }

  return Object.entries(profileCompletionRedirectTargets).some(
    ([token, url]) => token.endsWith('-local') && Boolean(url),
  )
}

const PACT_MOCK_SERVICE_URL = 'http://localhost:1234'
const SECONDSTEP_API_BASE = `https://api${SUBDOMAIN}.${HOST_DOMAIN}`

const urlMapping = {
  apiV4: `${SECONDSTEP_API_BASE}/v4`,
  app: `https://app${SUBDOMAIN}.${HOST_DOMAIN}`,
  cdn: 'https://web-assets-p-endpoint.azureedge.net',
  document: `https://func-apps${SUBDOMAIN}-document-service-func.${HOST_DOMAIN}/api`,
  learn: `https://learn${SUBDOMAIN}.${HOST_DOMAIN}`,
  lms: `https://lms${SUBDOMAIN}.${HOST_DOMAIN}`,
  publicSite: `https://www${SUBDOMAIN}.${HOST_DOMAIN}`,
  support: 'https://support.secondstep.org',
}

let lmsUrl = process.env.LOCAL_LMS
  ? 'http://localhost:8091'
  : `${urlMapping.lms}/api/v1`
let apiV4Url = urlMapping.apiV4

if (process.env.PACT_TESTING) {
  lmsUrl = PACT_MOCK_SERVICE_URL
  apiV4Url = PACT_MOCK_SERVICE_URL
}

const env = {
  default: {
    domains: {
      PUBLIC_SITE_DOMAIN: urlMapping.publicSite,
      STORE_DOMAIN: urlMapping.publicSite,
      APP_DOMAIN: urlMapping.app,
      CDN_DOMAIN: urlMapping.cdn,
      DOCUMENT_APP_DOMAIN: urlMapping.document,
      CURRICULUM_APP_DOMAIN: urlMapping.learn,
      PROFILE_COMPLETION_REDIRECT_TARGETS: profileCompletionRedirectTargets,
      PROFILE_COMPLETION_ALLOW_LOCAL_REDIRECT: allowProfileReturnLocalRedirect(),
      SUPPORT_DOMAIN: urlMapping.support,
      SS_API_V4: apiV4Url,
      LMS_API: lmsUrl,
    },
    appInsightsInstrumentationKey: APP_INSIGHTS_INSTRUMENTATION_KEY,
    auth0Settings: {
      domain: `login${SUBDOMAIN}.${HOST_DOMAIN}`,
      audience: 'secondstep-apis',
      clientId: AUTH_CLIENT_ID,
    },
  },
  local: {
    domains: {
      PUBLIC_SITE_DOMAIN: 'https://www-np-dev.cfctest.org',
      STORE_DOMAIN: 'https://store-np-dev.secondstep.org',
      APP_DOMAIN: 'http://localhost:3000',
      CDN_DOMAIN: urlMapping.cdn,
      DOCUMENT_APP_DOMAIN: `https://func-apps-np-dev-document-service-func.azurewebsites.net/api`,
      CURRICULUM_APP_DOMAIN: `https://localhost:4000`,
      PROFILE_COMPLETION_REDIRECT_TARGETS: profileCompletionRedirectTargets,
      PROFILE_COMPLETION_ALLOW_LOCAL_REDIRECT: allowProfileReturnLocalRedirect(),
      SUPPORT_DOMAIN: urlMapping.support,
      SS_API_V4: 'http://localhost:5010',
      LMS_API: 'http://localhost:8091/api/v1',
    },
    appInsightsInstrumentationKey: '47ea1da9-63d3-4099-9fef-c159ccd590bc',
    auth0Settings: {
      domain: `login-np-dev.cfctest.org`,
      audience: 'secondstep-apis',
      clientId: 'qfrKmK8DN5b3rsLXjCqFYrQeh46YYqUJ',
    },
  },
  localApp: {
    domains: {
      PUBLIC_SITE_DOMAIN: 'https://www-np-dev.cfctest.org',
      STORE_DOMAIN: 'https://store-np-dev.cfctest.org',
      APP_DOMAIN: 'http://localhost:3000',
      CDN_DOMAIN: urlMapping.cdn,
      DOCUMENT_APP_DOMAIN: `https://func-apps-np-dev-document-service-func.azurewebsites.net/api`,
      CURRICULUM_APP_DOMAIN: `https://learn-np-dev.cfctest.org`,
      PROFILE_COMPLETION_REDIRECT_TARGETS: profileCompletionRedirectTargets,
      PROFILE_COMPLETION_ALLOW_LOCAL_REDIRECT: allowProfileReturnLocalRedirect(),
      SUPPORT_DOMAIN: urlMapping.support,
      SS_API_V4: 'https://api-np-dev.cfctest.org/v4',
      LMS_API: process.env.LOCAL_LMS
        ? 'http://localhost:8091/api/v1'
        : 'https://lms-np-dev.cfctest.org/api/v1',
    },
    appInsightsInstrumentationKey: '47ea1da9-63d3-4099-9fef-c159ccd590bc',
    auth0Settings: {
      domain: `login-np-dev.cfctest.org`,
      audience: 'secondstep-apis',
      clientId: 'qfrKmK8DN5b3rsLXjCqFYrQeh46YYqUJ',
    },
  },
}

export const LD_CREDS = {
  clientSideId: LD_CLIENT_ID,
  user: {
    email: 'fakeAppUser@notrealdomain.org',
    kind: 'user',
    key: 'default_fake_app_user_key',
    name: 'Default Fake App User',
  },
}

export const urls = env[process.env.REACT_APP_ENV].urls
export const domains = env[process.env.REACT_APP_ENV].domains
export const apiEndpoint = env[process.env.REACT_APP_ENV].apiEndpoint
export const apiEndpointV2 = env[process.env.REACT_APP_ENV].apiEndpointV2
export const auth0Settings = env[process.env.REACT_APP_ENV].auth0Settings
export const appInsightsInstrumentationKey =
  env[process.env.REACT_APP_ENV].appInsightsInstrumentationKey
